import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import { FilterInputProps } from "./FilterInput.types";
import { FILTER_INPUT_HEIGHTS } from "../../DataTable.theme";

/**
 * Single-select filter input component.
 */
export const SelectFilter: React.FC<FilterInputProps> = ({
  value,
  onChange,
  density = "standard",
  options = [],
}) => {
  return (
    <FormControl size="small" fullWidth>
      <Select
        value={(value as string) || ""}
        onChange={(e) => onChange(e.target.value || null)}
        displayEmpty
        sx={{
          fontSize: density === "compact" ? "0.75rem" : "0.875rem",
          height: FILTER_INPUT_HEIGHTS[density],
        }}
      >
        <MenuItem value="">
          <em>Tutti</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
